import { Entity } from '../entity.js';
import { EFFECT_TYPES } from '../combat/statusEffects.js';
import { clampGroundCast, isInAbilityCircle, isWithinAbilityRange } from '../combat/abilityArea.js';

export function createSoraka(id = 'soraka-1', team = 'blue', x = 300, y = 1300) {
  return new Entity({
    id,
    type: 'champion',
    team,
    x,
    y,
    maxHp: 545,
    maxMp: 480,
    ad: 51,
    ap: 0,
    armor: 26,
    mr: 30,
    ms: 325,
    attackRange: 550,
    attackSpeed: 0.625,
    name: 'Soraka',
    radius: 20
  });
}

export function castSorakaQ(caster, x, y, entities = []) {
  if (!caster || caster.isDead || caster.mp < 45) return false;
  caster.mp -= 45;
  const aim = clampGroundCast(caster, x, y, 800);
  const damage = 55 + (caster.ap || 0) * 0.35;
  for (const e of entities) {
    if (!e || e.isDead || e.team === caster.team) continue;
    if (!isInAbilityCircle(e, aim.x, aim.y, 265, caster)) continue;
    e.takeDamage(damage, caster, 'magic');
    e.statusManager?.addEffect?.(EFFECT_TYPES.SLOW, 1.5, 0.3);
  }
  caster.hp = Math.min(caster.maxHp, caster.hp + 20 + (caster.ap || 0) * 0.1);
  return true;
}

export function castSorakaW(caster, entities = [], selectedTarget = null) {
  if (!caster || caster.isDead || caster.mp < 40) return false;
  if (caster.hp <= 40) return false;
  const ally = selectedTarget
    && selectedTarget.team === caster.team
    && !selectedTarget.isDead
    ? selectedTarget
    : entities.find((e) => e && e !== caster && e.team === caster.team && !e.isDead
      && isWithinAbilityRange(caster, e, 550, caster));
  const target = ally || caster;
  if (target !== caster && !isWithinAbilityRange(caster, target, 550, caster)) return false;
  caster.mp -= 40;
  caster.hp = Math.max(1, caster.hp - 40);
  const heal = 68 + (caster.ap || 0) * 0.5;
  target.hp = Math.min(target.maxHp, target.hp + heal);
  return true;
}

export function castSorakaE(caster, x, y, entities = []) {
  if (!caster || caster.isDead || caster.mp < 70) return false;
  caster.mp -= 70;
  const aim = clampGroundCast(caster, x, y, 925);
  for (const e of entities) {
    if (!e || e.isDead || e.team === caster.team) continue;
    if (!isInAbilityCircle(e, aim.x, aim.y, 260, caster)) continue;
    e.statusManager?.addEffect?.(EFFECT_TYPES.SILENCE, 1.5, 1);
    e.statusManager?.addEffect?.(EFFECT_TYPES.ROOT, 1.0, 1);
  }
  return true;
}

export function castSorakaR(caster, entities = []) {
  if (!caster || caster.isDead || caster.mp < 100) return false;
  caster.mp -= 100;
  const heal = 150 + (caster.ap || 0) * 0.55;
  for (const e of entities) {
    if (!e || e.isDead || e.team !== caster.team) continue;
    e.hp = Math.min(e.maxHp, e.hp + heal);
  }
  caster.hp = Math.min(caster.maxHp, caster.hp + heal);
  return true;
}
